module.exports = __webpack_public_path__ + "media/calling.64660fa9.mp3";